import { render } from "./ProductDetail_AuditDataModel.vue?vue&type=template&id=b66c864e&scoped=true"
import script from "./ProductDetail_AuditDataModel.vue?vue&type=script&lang=js"
export * from "./ProductDetail_AuditDataModel.vue?vue&type=script&lang=js"

import "./ProductDetail_AuditDataModel.vue?vue&type=style&index=0&id=b66c864e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66c864e"]])

export default __exports__